// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expense-editor {
  width: calc(100% + 48px);
  min-height: calc(100vh - 72px);
  box-sizing: border-box;
  margin: 0 -24px -8px;
  padding: 32px;
  background: var(--bg-primary, #f4f7f7);
  color: var(--text-primary, #142624);
  font: 400 13px var(--font-family-primary, "Lexend", sans-serif);
}
.expense-editor button,
.expense-editor input,
.expense-editor select,
.expense-editor textarea {
  font: inherit;
}
.expense-back {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 0;
  border: 0;
  background: transparent;
  color: var(--text-link, #0f766e);
  font-weight: 500;
  cursor: pointer;
}
.expense-editor__header {
  margin: 8px 0 28px;
}
.expense-editor__header h1 {
  margin: 0;
  font-size: 32px;
  line-height: 40px;
}
.expense-editor__header p {
  margin: 4px 0 0;
  color: var(--text-secondary, #506360);
}
.expense-editor__layout {
  display: grid;
  grid-template-columns: minmax(0, 680px) minmax(250px, 280px);
  gap: 24px;
  align-items: start;
}
.expense-editor__form {
  display: grid;
  gap: 20px;
}
.expense-editor__aside {
  display: grid;
  gap: 20px;
  position: sticky;
  top: 84px;
}
.expense-panel {
  padding: 20px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 14px;
  background: var(--surface-primary, #fff);
}
.expense-panel h2 {
  margin: 0 0 18px;
  font-size: 16px;
  font-weight: 500;
}
.expense-panel > p {
  color: var(--text-secondary, #506360);
}
.expense-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.expense-grid__wide {
  grid-column: 1/-1;
}
.expense-panel label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: var(--text-primary, #142624);
  font-weight: 500;
}
.expense-panel label > span:first-child {
  font-size: 12px;
}
.expense-panel input,
.expense-panel select,
.expense-panel textarea {
  width: 100%;
  min-width: 0;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 10px;
  outline: 0;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
}
.expense-panel input,
.expense-panel select {
  height: 40px;
  padding: 0 12px;
}
.expense-panel textarea {
  min-height: 112px;
  padding: 12px;
  resize: vertical;
}
.expense-panel input:hover:not(:disabled):not(:focus),
.expense-panel select:hover:not(:disabled):not(:focus),
.expense-panel textarea:hover:not(:disabled):not(:focus) {
  border-color: var(--border-strong, #8b9996);
}
.expense-panel input:focus,
.expense-panel select:focus,
.expense-panel textarea:focus {
  border: 2px solid var(--interactive-default, #0f766e);
  box-shadow: none;
}
.expense-panel input:disabled {
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-disabled, #8a9896);
}
.expense-editor .figma-datepicker__input,
.expense-editor .figma-datepicker__input:focus {
  border: 0;
  box-shadow: none;
}
.expense-editor .figma-datepicker__input-container:focus-within {
  box-shadow: none !important;
}
.expense-panel label small {
  color: var(--danger-default, #c23a2b);
  font-weight: 400;
}
.expense-editor .expense-theme-select {
  position: relative;
  min-width: 0;
  width: 100%;
}
.expense-editor .expense-theme-select .quotation-figma-dropdown-trigger {
  font: 400 14px/21.7px var(--font-family-primary, "Lexend", sans-serif);
  text-align: left;
}
.expense-editor
  .expense-theme-select:not(.is-open)
  .quotation-figma-dropdown-trigger:hover:not(:disabled):not(:focus-visible) {
  border-color: var(--border-strong, #8b9996);
}
.expense-editor .expense-theme-select.is-open .quotation-figma-dropdown-trigger,
.expense-editor .expense-theme-select .quotation-figma-dropdown-trigger:focus-visible {
  border: 1px solid var(--interactive-default, #0f766e);
  padding-inline: 12px 10px;
  box-shadow: none;
  outline: none;
}
.expense-editor .expense-theme-select .quotation-figma-dropdown-trigger:disabled {
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-disabled, #8a9896);
  cursor: not-allowed;
}
.expense-editor .expense-theme-select .quotation-figma-dropdown-menu {
  box-sizing: border-box;
  max-height: min(260px, 40vh);
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
}
.expense-editor .expense-theme-select .quotation-figma-dropdown-option {
  font: 400 14px/20px var(--font-family-primary, "Lexend", sans-serif);
}
.expense-editor .expense-supplier-search .quotation-input-box {
  height: 40px;
}
.expense-editor .expense-supplier-search .quotation-input-box:focus-within {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}
.expense-editor .expense-supplier-search .quotation-input-box.error {
  border-color: var(--danger-default, #c23a2b);
}
.expense-editor .expense-supplier-search .quotation-input-box input,
.expense-editor .expense-supplier-search .quotation-input-box input:focus {
  height: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}
.expense-editor .expense-supplier-search .quotation-input-box:has(input:disabled) {
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-disabled, #8a9896);
}
.expense-editor .expense-supplier-search .quotation-autocomplete-item {
  width: 100%;
  border: 0;
  background: transparent;
  text-align: left;
  overflow-wrap: anywhere;
}
.expense-editor .expense-supplier-search .quotation-autocomplete-item:hover,
.expense-editor .expense-supplier-search .quotation-autocomplete-item:focus-visible {
  background: var(--interactive-soft, #f0f8f7);
}
.expense-editor .expense-supplier-search .quotation-autocomplete-item > span {
  display: none;
}
.expense-info {
  margin-top: 16px;
  padding: 14px;
  border-radius: 10px;
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-secondary, #506360);
  line-height: 1.5;
}
.expense-balance {
  display: flex;
  justify-content: space-between;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
.expense-balance strong,
.expense-total,
.expense-panel dd {
  font-family: var(--font-family-mono, "JetBrains Mono", monospace);
}
.expense-upload {
  width: 100%;
  min-height: 128px;
  padding: 20px;
  border: 1px dashed var(--border-default, #cdd6d4);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-primary, #142624);
  cursor: pointer;
}
.expense-upload svg {
  width: 24px;
  height: 24px;
  color: var(--interactive-default, #0f766e);
}
.expense-upload span,
.expense-help {
  font-size: 11px;
  color: var(--text-secondary, #506360);
}
.expense-file-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}
.expense-file-actions button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 8px;
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  cursor: pointer;
}
.expense-file-actions button:disabled {
  cursor: wait;
  opacity: 0.65;
}
.expense-receipt-import {
  display: grid;
  gap: 4px;
  margin-top: 12px;
  padding: 12px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 20.2px;
}
.expense-receipt-import.is-success strong {
  color: var(--success-text, #115a33);
}
.expense-receipt-import.is-error {
  border-color: var(--danger-border, #fbc5c0);
  background: var(--danger-soft, #fef2f1);
  color: var(--danger-text, #a3301f);
}
.expense-total {
  display: block;
  font-size: 22px;
}
.expense-panel dl {
  margin: 0;
}
.expense-panel dl div {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}
.expense-panel dt,
.expense-panel dd {
  margin: 0;
}
.expense-primary,
.expense-secondary {
  width: 100%;
  min-height: 40px;
  margin-top: 10px;
  border-radius: 10px;
  cursor: pointer;
}
.expense-primary {
  border: 1px solid var(--interactive-default, #0f766e);
  background: var(--interactive-default, #0f766e);
  color: var(--on-interactive-primary, #fff);
}
.expense-secondary {
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
}
.expense-primary:disabled,
.expense-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.expense-viewer {
  position: fixed;
  inset: 0;
  z-index: 1400;
  display: grid;
  place-items: center;
  padding: 24px;
  background: var(--overlay-heavy, rgba(0, 0, 0, 0.72));
}
.expense-viewer > div {
  width: min(100%, 1000px);
  height: min(90vh, 800px);
  border-radius: 14px;
  overflow: hidden;
  background: var(--surface-primary, #fff);
}
.expense-viewer header {
  height: 56px;
  padding: 0 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}
.expense-viewer header button {
  padding: 8px 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 8px;
  background: transparent;
  color: var(--text-primary, #142624);
}
.expense-viewer iframe {
  width: 100%;
  height: calc(100% - 56px);
  border: 0;
}
.expense-editor__layout {
  width: 100%;
  grid-template-columns: minmax(0, 1fr) 320px;
}
.expense-editor__form,
.expense-editor__aside {
  min-width: 0;
}
.expense-panel {
  padding: 24px;
}
@media (max-width: 1000px) {
  .expense-editor__layout {
    grid-template-columns: 1fr;
  }
  .expense-editor__aside {
    position: static;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .expense-editor__aside .expense-save {
    grid-column: 1/-1;
  }
}
@media (max-width: 600px) {
  .expense-editor {
    padding: 20px 16px;
  }
  .expense-editor__header h1 {
    font-size: 24px;
    line-height: 30px;
  }
  .expense-editor__layout {
    gap: 16px;
  }
  .expense-panel {
    padding: 16px;
  }
  .expense-grid {
    grid-template-columns: 1fr;
  }
  .expense-grid__wide {
    grid-column: auto;
  }
  .expense-editor__aside {
    grid-template-columns: 1fr;
  }
  .expense-editor__aside .expense-save {
    grid-column: auto;
  }
  .expense-viewer {
    padding: 0;
  }
  .expense-viewer > div {
    height: 100vh;
    border-radius: 0;
  }
}
.expense-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.expense-button-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: expense-button-spin 0.7s linear infinite;
}
@keyframes expense-button-spin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Expenses/expenseEditor.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,sCAAsC;EACtC,mCAAmC;EACnC,+DAA+D;AACjE;AACA;;;;EAIE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;;;EAGE,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,mBAAmB;EACnB,UAAU;EACV,wCAAwC;EACxC,mCAAmC;AACrC;AACA;;EAEE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;AACA;;;EAGE,2CAA2C;AAC7C;AACA;;;EAGE,qDAAqD;EACrD,gBAAgB;AAClB;AACA;EACE,6CAA6C;EAC7C,oCAAoC;AACtC;AACA;;EAEE,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,sEAAsE;EACtE,gBAAgB;AAClB;AACA;;;EAGE,2CAA2C;AAC7C;AACA;;EAEE,qDAAqD;EACrD,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,6CAA6C;EAC7C,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,oEAAoE;AACtE;AACA;EACE,YAAY;AACd;AACA;EACE,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,4CAA4C;AAC9C;AACA;;EAEE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,6CAA6C;EAC7C,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;EAEE,4CAA4C;AAC9C;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,6CAA6C;EAC7C,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,mDAAmD;AACrD;AACA;;;EAGE,iEAAiE;AACnE;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,iDAAiD;EACjD,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6CAA6C;EAC7C,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;AACA;;EAEE,eAAe;EACf,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gDAAgD;EAChD,kBAAkB;EAClB,wCAAwC;EACxC,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,+CAA+C;EAC/C,qCAAqC;EACrC,6CAA6C;EAC7C,qCAAqC;EACrC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,sDAAsD;AACxD;AACA;;EAEE,SAAS;AACX;AACA;;EAEE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,qDAAqD;EACrD,+CAA+C;EAC/C,0CAA0C;AAC5C;AACA;EACE,gDAAgD;EAChD,wCAAwC;EACxC,mCAAmC;AACrC;AACA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,qDAAqD;AACvD;AACA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sDAAsD;AACxD;AACA;EACE,iBAAiB;EACjB,gDAAgD;EAChD,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,WAAW;EACX,2CAA2C;AAC7C;AACA;;EAEE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;IAChB,gDAAgD;EAClD;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;AACF;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,mDAAmD;AACrD;AACA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".expense-editor {\n  width: calc(100% + 48px);\n  min-height: calc(100vh - 72px);\n  box-sizing: border-box;\n  margin: 0 -24px -8px;\n  padding: 32px;\n  background: var(--bg-primary, #f4f7f7);\n  color: var(--text-primary, #142624);\n  font: 400 13px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.expense-editor button,\n.expense-editor input,\n.expense-editor select,\n.expense-editor textarea {\n  font: inherit;\n}\n.expense-back {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 0;\n  border: 0;\n  background: transparent;\n  color: var(--text-link, #0f766e);\n  font-weight: 500;\n  cursor: pointer;\n}\n.expense-editor__header {\n  margin: 8px 0 28px;\n}\n.expense-editor__header h1 {\n  margin: 0;\n  font-size: 32px;\n  line-height: 40px;\n}\n.expense-editor__header p {\n  margin: 4px 0 0;\n  color: var(--text-secondary, #506360);\n}\n.expense-editor__layout {\n  display: grid;\n  grid-template-columns: minmax(0, 680px) minmax(250px, 280px);\n  gap: 24px;\n  align-items: start;\n}\n.expense-editor__form {\n  display: grid;\n  gap: 20px;\n}\n.expense-editor__aside {\n  display: grid;\n  gap: 20px;\n  position: sticky;\n  top: 84px;\n}\n.expense-panel {\n  padding: 20px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 14px;\n  background: var(--surface-primary, #fff);\n}\n.expense-panel h2 {\n  margin: 0 0 18px;\n  font-size: 16px;\n  font-weight: 500;\n}\n.expense-panel > p {\n  color: var(--text-secondary, #506360);\n}\n.expense-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n.expense-grid__wide {\n  grid-column: 1/-1;\n}\n.expense-panel label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  color: var(--text-primary, #142624);\n  font-weight: 500;\n}\n.expense-panel label > span:first-child {\n  font-size: 12px;\n}\n.expense-panel input,\n.expense-panel select,\n.expense-panel textarea {\n  width: 100%;\n  min-width: 0;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 10px;\n  outline: 0;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n}\n.expense-panel input,\n.expense-panel select {\n  height: 40px;\n  padding: 0 12px;\n}\n.expense-panel textarea {\n  min-height: 112px;\n  padding: 12px;\n  resize: vertical;\n}\n.expense-panel input:hover:not(:disabled):not(:focus),\n.expense-panel select:hover:not(:disabled):not(:focus),\n.expense-panel textarea:hover:not(:disabled):not(:focus) {\n  border-color: var(--border-strong, #8b9996);\n}\n.expense-panel input:focus,\n.expense-panel select:focus,\n.expense-panel textarea:focus {\n  border: 2px solid var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n.expense-panel input:disabled {\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-disabled, #8a9896);\n}\n.expense-editor .figma-datepicker__input,\n.expense-editor .figma-datepicker__input:focus {\n  border: 0;\n  box-shadow: none;\n}\n.expense-editor .figma-datepicker__input-container:focus-within {\n  box-shadow: none !important;\n}\n.expense-panel label small {\n  color: var(--danger-default, #c23a2b);\n  font-weight: 400;\n}\n.expense-editor .expense-theme-select {\n  position: relative;\n  min-width: 0;\n  width: 100%;\n}\n.expense-editor .expense-theme-select .quotation-figma-dropdown-trigger {\n  font: 400 14px/21.7px var(--font-family-primary, \"Lexend\", sans-serif);\n  text-align: left;\n}\n.expense-editor\n  .expense-theme-select:not(.is-open)\n  .quotation-figma-dropdown-trigger:hover:not(:disabled):not(:focus-visible) {\n  border-color: var(--border-strong, #8b9996);\n}\n.expense-editor .expense-theme-select.is-open .quotation-figma-dropdown-trigger,\n.expense-editor .expense-theme-select .quotation-figma-dropdown-trigger:focus-visible {\n  border: 1px solid var(--interactive-default, #0f766e);\n  padding-inline: 12px 10px;\n  box-shadow: none;\n  outline: none;\n}\n.expense-editor .expense-theme-select .quotation-figma-dropdown-trigger:disabled {\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-disabled, #8a9896);\n  cursor: not-allowed;\n}\n.expense-editor .expense-theme-select .quotation-figma-dropdown-menu {\n  box-sizing: border-box;\n  max-height: min(260px, 40vh);\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  scrollbar-width: thin;\n}\n.expense-editor .expense-theme-select .quotation-figma-dropdown-option {\n  font: 400 14px/20px var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.expense-editor .expense-supplier-search .quotation-input-box {\n  height: 40px;\n}\n.expense-editor .expense-supplier-search .quotation-input-box:focus-within {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n.expense-editor .expense-supplier-search .quotation-input-box.error {\n  border-color: var(--danger-default, #c23a2b);\n}\n.expense-editor .expense-supplier-search .quotation-input-box input,\n.expense-editor .expense-supplier-search .quotation-input-box input:focus {\n  height: 100%;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  box-shadow: none;\n}\n.expense-editor .expense-supplier-search .quotation-input-box:has(input:disabled) {\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-disabled, #8a9896);\n}\n.expense-editor .expense-supplier-search .quotation-autocomplete-item {\n  width: 100%;\n  border: 0;\n  background: transparent;\n  text-align: left;\n  overflow-wrap: anywhere;\n}\n.expense-editor .expense-supplier-search .quotation-autocomplete-item:hover,\n.expense-editor .expense-supplier-search .quotation-autocomplete-item:focus-visible {\n  background: var(--interactive-soft, #f0f8f7);\n}\n.expense-editor .expense-supplier-search .quotation-autocomplete-item > span {\n  display: none;\n}\n.expense-info {\n  margin-top: 16px;\n  padding: 14px;\n  border-radius: 10px;\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-secondary, #506360);\n  line-height: 1.5;\n}\n.expense-balance {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 18px;\n  padding-top: 14px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n.expense-balance strong,\n.expense-total,\n.expense-panel dd {\n  font-family: var(--font-family-mono, \"JetBrains Mono\", monospace);\n}\n.expense-upload {\n  width: 100%;\n  min-height: 128px;\n  padding: 20px;\n  border: 1px dashed var(--border-default, #cdd6d4);\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-primary, #142624);\n  cursor: pointer;\n}\n.expense-upload svg {\n  width: 24px;\n  height: 24px;\n  color: var(--interactive-default, #0f766e);\n}\n.expense-upload span,\n.expense-help {\n  font-size: 11px;\n  color: var(--text-secondary, #506360);\n}\n.expense-file-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n}\n.expense-file-actions button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 10px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 8px;\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  cursor: pointer;\n}\n.expense-file-actions button:disabled {\n  cursor: wait;\n  opacity: 0.65;\n}\n.expense-receipt-import {\n  display: grid;\n  gap: 4px;\n  margin-top: 12px;\n  padding: 12px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 20.2px;\n}\n.expense-receipt-import.is-success strong {\n  color: var(--success-text, #115a33);\n}\n.expense-receipt-import.is-error {\n  border-color: var(--danger-border, #fbc5c0);\n  background: var(--danger-soft, #fef2f1);\n  color: var(--danger-text, #a3301f);\n}\n.expense-total {\n  display: block;\n  font-size: 22px;\n}\n.expense-panel dl {\n  margin: 0;\n}\n.expense-panel dl div {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n.expense-panel dt,\n.expense-panel dd {\n  margin: 0;\n}\n.expense-primary,\n.expense-secondary {\n  width: 100%;\n  min-height: 40px;\n  margin-top: 10px;\n  border-radius: 10px;\n  cursor: pointer;\n}\n.expense-primary {\n  border: 1px solid var(--interactive-default, #0f766e);\n  background: var(--interactive-default, #0f766e);\n  color: var(--on-interactive-primary, #fff);\n}\n.expense-secondary {\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n}\n.expense-primary:disabled,\n.expense-secondary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.expense-viewer {\n  position: fixed;\n  inset: 0;\n  z-index: 1400;\n  display: grid;\n  place-items: center;\n  padding: 24px;\n  background: var(--overlay-heavy, rgba(0, 0, 0, 0.72));\n}\n.expense-viewer > div {\n  width: min(100%, 1000px);\n  height: min(90vh, 800px);\n  border-radius: 14px;\n  overflow: hidden;\n  background: var(--surface-primary, #fff);\n}\n.expense-viewer header {\n  height: 56px;\n  padding: 0 18px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n.expense-viewer header button {\n  padding: 8px 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-primary, #142624);\n}\n.expense-viewer iframe {\n  width: 100%;\n  height: calc(100% - 56px);\n  border: 0;\n}\n.expense-editor__layout {\n  width: 100%;\n  grid-template-columns: minmax(0, 1fr) 320px;\n}\n.expense-editor__form,\n.expense-editor__aside {\n  min-width: 0;\n}\n.expense-panel {\n  padding: 24px;\n}\n@media (max-width: 1000px) {\n  .expense-editor__layout {\n    grid-template-columns: 1fr;\n  }\n  .expense-editor__aside {\n    position: static;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .expense-editor__aside .expense-save {\n    grid-column: 1/-1;\n  }\n}\n@media (max-width: 600px) {\n  .expense-editor {\n    padding: 20px 16px;\n  }\n  .expense-editor__header h1 {\n    font-size: 24px;\n    line-height: 30px;\n  }\n  .expense-editor__layout {\n    gap: 16px;\n  }\n  .expense-panel {\n    padding: 16px;\n  }\n  .expense-grid {\n    grid-template-columns: 1fr;\n  }\n  .expense-grid__wide {\n    grid-column: auto;\n  }\n  .expense-editor__aside {\n    grid-template-columns: 1fr;\n  }\n  .expense-editor__aside .expense-save {\n    grid-column: auto;\n  }\n  .expense-viewer {\n    padding: 0;\n  }\n  .expense-viewer > div {\n    height: 100vh;\n    border-radius: 0;\n  }\n}\n.expense-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n.expense-button-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: expense-button-spin 0.7s linear infinite;\n}\n@keyframes expense-button-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
